import { FieldPath, FieldValues } from 'react-hook-form';
import { disabledFieldsSignify, DisabledFieldsSignifyType } from '../index.store';

export const setFieldDisabledHandler =
  <TFieldValues extends FieldValues = FieldValues>(formName: string) =>
  (fieldName: FieldPath<TFieldValues>, disabled: boolean) => {
    disabledFieldsSignify.set((prev) => {
      if (prev.value[formName][fieldName] === disabled) {
        return;
      }

      prev.value[formName][fieldName] = disabled;
    });
  };

export const getFieldDisabledHandler =
  <TFieldValues extends FieldValues = FieldValues>(
    disabledFields: DisabledFieldsSignifyType<TFieldValues>,
    formName: string
  ) =>
  (fieldName?: FieldPath<TFieldValues>) => {
    return fieldName ? disabledFields[formName][fieldName] : disabledFields[formName];
  };
